import React from 'react';

import TracklogMapControls from 'ff/debrief/components/map/TracklogMapControls';
import FlightDetails from 'ff/debrief/components/details';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import SharedSidebar from 'ff/debrief/components/sidebar/SharedSidebar';
import MapAreaGrid from 'ff/debrief/layouts/MapAreaGrid';
import {
    RouteContext,
    LinkToSharedDebrief,
    LinkToShared,
} from 'ff/debrief/router';

export const pathString = '/shared/:tracklogId?';

const SharedRoute = () => {
    return (
        <RouteContext.Provider
            value={{
                returnLink: LinkToShared,
                debriefLink: LinkToSharedDebrief,
                page: 'SharedWithMeView',
            }}
        >
            <MapAreaGrid>
                <TracklogMapControls />
                <SharedSidebar />
                <FlightDetails />
                <ErrorBar />
            </MapAreaGrid>
        </RouteContext.Provider>
    );
};

export default SharedRoute;
